import React from 'react';
import styles from '../joycceventura_/joycceventura_.module.scss';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import catalogoPdf from './src/catalogo.pdf';
import bg from './src/background-links.png';
import logo from './src/logo.png';

const Joycceventura_: React.FC = () => {

    return (
        <div className={styles.joycceventura_}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img src={bg} width={"70%"} />
                    <h1>JOYCE CRISTTYNA</h1>
                    <p>ESPECIALISTA EM SOBRANCELHAS</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5517991446744?text=Olá, gostaria de mais informações..."
                            title="AGENDAMENTO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><WhatsappIcon height="40" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href={catalogoPdf}
                            title="CATÁLOGO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "10px",
                                borderRadius: "100%",
                            }}><CatalogIcon height="34" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/joycce_cris?igsh=MTV1amtrazNwNHQ3NA%3D%3D&utm_source=qr"
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "10px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/t7hfRcjfQy3FViUS9"
                            title="LOCALIZAÇÃO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#cbb353",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><MapsIcon height="40" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                    </div>
                    <img src={logo} className="mt-4" width={"50%"} />
                </div>
            </div>
        </div>
    );
};

export default Joycceventura_;
